import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterFietsenwinkelPage() {
  return <ClusterPageTemplate clusterName="Fietsenwinkel" sectorName="Lokale Retail & Dienstverlening" sectorSlug="lokale-retail" heroTitle="Website laten maken voor een fietsenwinkel" heroDescription="Een moderne, overzichtelijke website voor jouw fietsenwinkel of reparatiezaak. Wij bouwen websites die klanten naar de winkel trekken voor aankoop en onderhoud." websiteOnderdelen={[{
    icon: 'BikeIcon',
    title: 'Assortiment',
    description: 'Presentatie van de merken en soorten fietsen (e-bikes, stadsfietsen, racefietsen) die je verkoopt.'
  }, {
    icon: 'WrenchIcon',
    title: 'Werkplaats & Reparatie',
    description: 'Informatie over onderhoudsbeurten, reparatietarieven en de mogelijkheid om een afspraak in te plannen.'
  }, {
    icon: 'MapPinIcon',
    title: 'Winkel & Proefrit',
    description: 'Duidelijke openingstijden, routebeschrijving en een formulier om een proefrit aan te vragen.'
  }, {
    icon: 'ShieldCheckIcon',
    title: 'Service & Garantie',
    description: 'Uitleg over fietsverzekeringen, lease-mogelijkheden, fietsplannen en garantieregelingen.'
  }]} functionaliteiten={[{
    icon: 'CalendarCheckIcon',
    title: 'Werkplaatsplanner',
    description: 'Een module waarmee klanten online een afspraak kunnen maken voor een reparatie of onderhoudsbeurt.'
  }, {
    icon: 'ShoppingCartIcon',
    title: 'Webshop (optioneel)',
    description: 'Mogelijkheid om fietsen, accessoires of onderdelen direct online te verkopen via WooCommerce.'
  }, {
    icon: 'SearchIcon',
    title: 'Lokale SEO',
    description: "Word gevonden op zoektermen als 'fietsenmaker [jouw stad]' of 'e-bike kopen in de buurt'."
  }]} siblingClusters={[{
    name: 'Kapsalon',
    slug: 'kapsalon'
  }, {
    name: 'Garage',
    slug: 'garage'
  }, {
    name: 'Autobedrijf',
    slug: 'autobedrijf'
  }]} faqs={[{
    q: 'Kan ik ook een webshop aan de website toevoegen?',
    a: 'Ja, we kunnen de website bouwen met WooCommerce, waardoor je direct online fietsen of accessoires kunt verkopen.'
  }, {
    q: 'Hoe zorg ik dat de werkplaats efficiënter gepland wordt?',
    a: 'We kunnen een online werkplaatsplanner integreren. Klanten plannen zelf hun reparatie in, wat jou veel telefoontjes scheelt.'
  }, {
    q: 'Wat kost een website voor een fietsenwinkel?',
    a: 'Een informatieve website start vanaf €1.500. Wil je een uitgebreide webshop met honderden producten, dan maken we een offerte op maat.'
  }, {
    q: 'Koppelen jullie met kassasystemen zoals WilMar of Vendit?',
    a: 'Voor webshops kunnen we (vaak via externe plugins) koppelingen realiseren met de bekende kassasystemen in de tweewielerbranche voor voorraadbeheer.'
  }]} data-id="element-1079" />;
}